import { Percent } from "@mui/icons-material"
import { CaseActivity } from "../hooks/useList"
import { upsert } from "../hooks/useQueryData"
import { CaseRecord } from "../models/Case"
import { ActivityRecord } from "../records/ActivityRecord"
import { ConvertDateForDBOn, DaysBetweenDates, Today } from "../utils"
import { deleteDataId, fetchData, fetchDataId } from "./MiddleTierData"
import { CalcSiteOverview } from "../domain/SiteSummary"
import { SetCaseSummaryFromCase, SetCaseSummaryFromContact, SetCaseSummaryFromLitigations, SetCaseSummaryFromOffers, SetCSDocCounts, SetCSProgressAlerts, SetTreatments } from "../domain/CaseSummary"

export async function updateCaseSummaryById(caseId: string, cs: object | null, activity: ActivityRecord | null) {
  const c = await fetchDataId('Case', caseId)
  if (c) {
    await updateCaseSummary(c, cs, activity)
  }
}

export async function updateCaseSummary(c: CaseRecord | string, cs: object | null, activity: ActivityRecord | null) {
  if (typeof c === 'string' || c?.Status === "Closed") {
    // Deleted or closed Case. Remove CaseSummary
    const delCaseSumm = await fetchData('CaseSummary', { Where: [{ kind: 'equals', field: 'CaseId', value: c?._id ?? "" }] })
    // We shouldn't have multiple CaseSummaries for a Case, but just in case...
    for (const cs of delCaseSumm.data) {
      await deleteDataId('CaseSummary', cs._id)
    }
    return
  }

  if (!c?._id) return // If c is not a valid CaseRecord, then we can't update the CaseSummary

  let caseSummary = cs
  if (!caseSummary) {
    // If cs is null, then we need to fetch the existing CaseSummary
    const results = await fetchData('CaseSummary', { Where: [{ kind: 'equals', field: 'CaseId', value: c._id }] })
    caseSummary = results.data[0]
  }

  // If we still don't have a caseSummary, then create a new one
  if (!caseSummary) { caseSummary = { CaseId: c._id } }

  // If we are sent an activity, then it's the only update to CaseSummary.
  // TODO:RTP Write separate logic to update CaseSummary based on Activity type
  // if (activity) {
  //   addActivityToCaseSummary(caseSummary, activity)
  // } else {
    SetCaseSummaryFromCase(c, caseSummary)

    const contact = await fetchDataId('Contact', c.Client)
    SetCaseSummaryFromContact(contact, c.Client, caseSummary)

    const acts = await fetchData('Activity', { Where: [{kind: 'equals', field: 'CaseId', value: c._id}], Sort: { field: 'On', order: 'desc' } })
    const activityMeta = (await fetchData('ActivityAlerts')).data
    SetCSProgressAlerts(c, acts.data ?? [], activityMeta, caseSummary)

    const offers = await fetchData('Offer', { Where: [{kind: 'equals', field: 'CaseId', value: c._id}]})
    SetCaseSummaryFromOffers(offers.data ?? [], caseSummary)

    const lits = await fetchData('Litigation', { Where: [{kind: 'equals', field: 'CaseId', value: c._id}]})
    SetCaseSummaryFromLitigations(lits.data ?? [], caseSummary)

    const docs = await fetchData('Document', { Where: [{ kind: 'equals', field: 'CaseId', value: c._id }] })
    SetCSDocCounts(docs.data ?? [], caseSummary)

    const treatments = await fetchData('Treatment', { Where: [{ kind: 'equals', field: 'CaseId', value: c._id }] })
    SetTreatments(treatments.data ?? [], caseSummary)
  // }

    console.log("Updating CaseSummary", caseSummary)
    await upsert('CaseSummary', caseSummary)
}

export async function rebuildOverview() {
  const cases = await fetchData('Case', { Where: [{kind: 'notEquals', field: 'Status', value: 'Closed'}]})      
  const css = await fetchData('CaseSummary')      
  const sum = CalcSiteOverview(cases.data, css.data)
  const result = await upsert('Summary', sum);
}

async function calculateOffers(c: CaseRecord) {
    let results = await fetchData('Offer', { Where: [{kind: 'equals', field: 'CaseId', value: c._id}], Sort: {field: 'Date', order: 'desc'} })
    const offers = results.data.map((o: any) => ({Date: o?.Date, From: o?.From, Amount: o?.Amount}))

    return offers
}